import { createContext, useContext } from 'react'

/**
 * The portal target for every overlay — sheets, scrims, toasts.
 *
 * It is a context rather than `document.getElementById('overlay-root')` because
 * the node lives *inside* `PhoneFrame`, not at body level. That is the whole
 * point of rule 2 in the README: an overlay rendered at body level covers a
 * 1920px page, and the scrim darkens the desktop instead of the phone column.
 * Passing the node through React makes the boundary structural — there is no
 * global to reach for, so there is nothing to reach for by accident.
 *
 * `null` until `AppShell` has mounted its container. Consumers render nothing
 * while it is null rather than throwing: an overlay that appears one frame late
 * is a non-event, an overlay that crashes the shell is not. SUAP-0104.
 */
export const OverlayContext = createContext<HTMLElement | null>(null)

export function useOverlayRoot(): HTMLElement | null {
  return useContext(OverlayContext)
}
